import React, { type ReactNode } from 'react';
import classNames from 'classnames';
import useFontClassName from '../../hooks/use-font-class-name';
import useIsFeedDesignEnabled from '../../hooks/use-is-feed-design-enabled';
import { usePostBorderWidth } from '../../hooks/use-post-border-width';
import styles from './empty-states.scss';

type EmptyStatesProps = {
  children?: ReactNode;
  className?: string;
  style?: object;
  isLayoutTextOnImage?: boolean;
  title?: string;
  content?: string;
  titleClassName?: string;
};

const EmptyStates: React.FC<EmptyStatesProps> = ({
  title,
  content,
  style = {},
  className,
  children,
  isLayoutTextOnImage = false,
  titleClassName,
}) => {
  const { borderWidth } = usePostBorderWidth();
  const { getPostClassName } = useIsFeedDesignEnabled();

  const { titleFontClassName, contentFontClassName } = useFontClassName();

  const containerClassName = classNames(
    styles.container,
    contentFontClassName,
    className,
    isLayoutTextOnImage
      ? styles.isLayoutTextOnImage
      : ['blog-card-background-color', 'blog-text-color'],
    'blog-card-border-color',
    getPostClassName?.('border-color', 'post-container', 'background-color'),
  );

  const titleContainerClassName = classNames(
    titleFontClassName,
    titleClassName,
    getPostClassName?.('title-font', 'title-color'),
  );

  const contentContainerClassName = classNames(
    styles.content,
    getPostClassName?.('description-font', 'description-color'),
  );

  return (
    <div
      data-hook="empty-state-container"
      className={containerClassName}
      style={{ borderWidth, ...style }}
    >
      <div className={titleContainerClassName} data-hook="empty-states__title">
        <div tabIndex={0} className={styles.header}>
          {title}
        </div>
      </div>
      <div className={contentContainerClassName}>
        <div className={styles.description}>{content}</div>
      </div>
      {children && <div className={styles.controls}>{children}</div>}
    </div>
  );
};

export default EmptyStates;
